(function () {
  function formatNumber(value, decimals) {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function formatMoney(value) {
    return "$" + formatNumber(value, 2);
  }

  function showNumberResult(result, label, value, suffix, decimals) {
    result.innerHTML =
      "<strong>" + label + "</strong>" +
      '<div style="font-size:24px;font-weight:700;margin-top:6px;">' +
      formatNumber(value, decimals) +
      suffix +
      "</div>";
  }

  function runCalculator(calculator) {
    var base = parseFloat(calculator.getAttribute("data-base") || "1");
    var formula = calculator.getAttribute("data-formula") || "multiply";
    var output = calculator.getAttribute("data-output") || "money-range";
    var decimals = parseInt(calculator.getAttribute("data-decimals") || "2", 10);
    var label = calculator.getAttribute("data-label") || "Estimated Price";
    var suffix = calculator.getAttribute("data-suffix") || "";
    var result = calculator.querySelector("[data-result]");
    var fields = calculator.querySelectorAll("[data-factor]");

    if (!result) return;

    var total = base;
    var sizeHandled = false;

    fields.forEach(function (field) {
      var value = parseFloat(field.value);

      if (isNaN(value)) {
        result.innerText = "Please complete all fields.";
        total = null;
        return;
      }

      if (formula === "size-power" && field.getAttribute("data-role") === "size") {
        total = Math.pow(value, 2.4) * base;
        sizeHandled = true;
      } else if (formula === "divide") {
        total = value / base;
      } else {
        total = total * value;
      }
    });

    if (total === null) return;

    if (formula === "size-power" && !sizeHandled) {
      result.innerText = "Calculator size field is missing.";
      return;
    }

    if (output === "number") {
      showNumberResult(result, label, total, suffix, decimals);
      return;
    }

    var low = total * 0.85;
    var high = total * 1.15;

    result.innerHTML =
      "<strong>" + label + "</strong>" +
      '<div style="font-size:24px;font-weight:700;margin-top:6px;">' +
      formatMoney(low) +
      " - " +
      formatMoney(high) +
      "</div>" +
      '<div style="font-size:12px;color:#666;margin-top:8px;">Educational estimate only. Actual prices may vary.</div>';
  }

  function runConversion(button) {
    var group = button.closest("[data-converter]");
    if (!group) return;

    var input = group.querySelector("[data-convert-input]");
    var result = group.querySelector("[data-convert-result]");
    var factor = parseFloat(button.getAttribute("data-factor") || "1");
    var mode = button.getAttribute("data-mode") || "multiply";
    var decimals = parseInt(button.getAttribute("data-decimals") || "4", 10);
    var fromLabel = button.getAttribute("data-from") || "";
    var toLabel = button.getAttribute("data-to") || "";

    if (!input || !result) return;

    var value = parseFloat(input.value);

    if (isNaN(value)) {
      result.innerText = "Please enter a value.";
      return;
    }

    var converted = mode === "divide" ? value / factor : value * factor;

    result.innerText =
      formatNumber(value, decimals) +
      " " +
      fromLabel +
      " is " +
      formatNumber(converted, decimals) +
      " " +
      toLabel +
      ".";
  }

  function runRingSizeCalculator(button) {
    var calculator = button.closest("[data-ring-size-calculator]");
    if (!calculator) return;

    var measurementInput = calculator.querySelector("[data-ring-measurement]");
    var unitInput = calculator.querySelector("[data-ring-unit]");
    var result = calculator.querySelector("[data-ring-result]");

    if (!measurementInput || !unitInput || !result) return;

    var measurement = parseFloat(measurementInput.value);
    var unit = unitInput.value;

    if (isNaN(measurement) || measurement <= 0) {
      result.innerHTML = "<strong>Please enter a valid finger circumference.</strong>";
      return;
    }

    var circumference = unit === "inches" ? measurement * 25.4 : measurement;

    var sizes = [
      { min: 49.3, max: 50.6, us: "5", uk: "H 1/2", eu: "49.3", japan: "9" },
      { min: 50.6, max: 51.9, us: "6", uk: "J 1/2", eu: "50.6", japan: "12" },
      { min: 51.9, max: 53.1, us: "7", uk: "L", eu: "51.9", japan: "14" },
      { min: 53.1, max: 54.4, us: "8", uk: "M 1/2", eu: "53.1", japan: "16" },
      { min: 54.4, max: 55.7, us: "9", uk: "O", eu: "54.4", japan: "18" },
      { min: 55.7, max: 57.0, us: "10", uk: "P 1/2", eu: "55.7", japan: "20" },
      { min: 57.0, max: 58.3, us: "11", uk: "R", eu: "57.0", japan: "22" },
      { min: 58.3, max: 59.5, us: "12", uk: "S 1/2", eu: "58.3", japan: "24" },
      { min: 59.5, max: 60.8, us: "13", uk: "T 1/2", eu: "59.5", japan: "26" },
      { min: 60.8, max: 62.1, us: "14", uk: "V", eu: "60.8", japan: "28" },
      { min: 62.1, max: Infinity, us: "15", uk: "W 1/2", eu: "62.1", japan: "30" }
    ];

    var match = sizes.find(function (size) {
      return circumference >= size.min && circumference < size.max;
    });

    if (!match) {
      result.innerHTML = "<strong>Invalid measurement. Please try again.</strong>";
      return;
    }

    result.innerHTML =
      "<p><strong>Your ring size is:</strong></p>" +
      "<ul style='text-align:left;display:inline-block;margin:8px auto 0;'>" +
      "<li><strong>US:</strong> " + match.us + "</li>" +
      "<li><strong>UK:</strong> " + match.uk + "</li>" +
      "<li><strong>EU:</strong> " + match.eu + "</li>" +
      "<li><strong>Japan:</strong> " + match.japan + "</li>" +
      "</ul>";
  }

  function startSairahazCalculators() {
    document.querySelectorAll("[data-sairahaz-calculator]").forEach(function (calculator) {
      var button = calculator.querySelector("[data-calculate]");
      if (!button) return;

      button.addEventListener("click", function () {
        runCalculator(calculator);
      });
    });

    document.querySelectorAll("[data-convert]").forEach(function (button) {
      button.addEventListener("click", function () {
        runConversion(button);
      });
    });

    document.querySelectorAll("[data-ring-calculate]").forEach(function (button) {
      button.addEventListener("click", function () {
        runRingSizeCalculator(button);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startSairahazCalculators);
  } else {
    startSairahazCalculators();
  }
})();